<template>
  <div class="new-cls content">
    <Tabs
      :tabsList="tabsList"
      style="padding: 0 24px"
      :activeName="activeVal"
      @tab-click="handleChange"
    >
    </Tabs>

    <!-- 开户 -->
    <AccountInfo v-if="activeVal == '1'" :type="activeType" />
    <!-- 截单时间 -->
    <CutOffInfo v-if="activeVal == '2'" :type="activeType" />
    <!-- 工作时间 -->
    <WorkDayInfo v-if="activeVal == '3'" :type="activeType" />
    <!-- 发货 -->
    <SendGoodsInfo v-if="activeVal == '4'" :type="activeType" />
    <!-- 物流 -->
    <LogisticsInfo v-if="activeVal == '5'" :type="activeType" />
    <!-- 发票 -->
    <InvoiceInfo v-if="activeVal == '6'" :type="activeType" />
    <!-- 包邮 -->
    <FreeshippingInfo v-if="activeVal == '7'" :type="activeType" />
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import AccountInfo from "./children2/AccountInfo.vue";
import CutOffInfo from "./children2/CutOffInfo.vue";
import WorkDayInfo from "./children2/WorkDayInfo.vue";
import SendGoodsInfo from "./children2/SendGoodsInfo.vue";
import LogisticsInfo from "./children2/LogisticsInfo.vue";
import InvoiceInfo from "./children2/InvoiceInfo.vue";
import FreeshippingInfo from "./children2/FreeshippingInfo.vue";

export default {
  components: {
    Tabs,
    AccountInfo,
    CutOffInfo,
    WorkDayInfo,
    SendGoodsInfo,
    LogisticsInfo,
    InvoiceInfo,
    FreeshippingInfo,
  },
  data() {
    return {
      activeVal: "1",

      tabsList: [
        {
          name: "1",
          label: "开户",
          value: "OPEN_ACCOUNT",
        },
        {
          name: "2",
          label: "截单时间",
          value: "CLOSING_TIME",
        },
        {
          name: "3",
          label: "工作时间",
          value: "WORKING_HOURS",
        },
        {
          name: "4",
          label: "发货",
          value: "DELIVER_GOODS",
        },
        {
          name: "5",
          label: "物流",
          value: "MATERIAL_FLOW",
        },
        {
          name: "6",
          label: "发票",
          value: "INVOICE",
        },
        {
          name: "7",
          label: "包邮",
          value: "EXEMPT_POSTAGE",
        },
      ],
    };
  },
  computed: {
    activeType() {
      const findedItem = this.tabsList.find(
        (item) => item.name === this.activeVal
      );
      return findedItem ? findedItem.value : "";
    },
  },
  methods: {
    handleChange(val) {
      this.activeVal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;
  height: calc(100vh - 140px);
  ::v-deep .el-tabs__item {
    padding: 0 12px;
    margin-right: 0px;
  }
}
</style>
